import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './ProposalGenerator/ProposalBox.css';

const getPriceForProduct = (product, priceKey) => {
  if (!product) {
    return null;
  }
  return product.priceList.find(price => price.key === priceKey);
};

const getNetPrice = (price, quantity) => {
  return (price * quantity).toFixed(2);
};

const sortCount = box => {
  let arr = [];
  box.map(prod =>
    prod.products.map(item => {
      if (item.selected) {
        arr.push(item);
      }
    }),
  );
  function byField(field) {
    return (a, b) => (a[field] > b[field] ? 1 : -1);
  }
  return arr.sort(byField('count'));
};

const ProposalBoxView = ({ box, priceKey, boxTotal, tollFreeNumber }) => {
  const { productGroups } = box;

  useEffect(() => {
    sortCount(productGroups).map(prod => {
      if (prod.description === 'Toll-Free Number') {
        tollFreeNumber(true);
      }
    });
  }, []);

  return (
    <>
      {sortCount(productGroups).map(prod => {
        const productPrice = getPriceForProduct(prod, priceKey);
        if (!productPrice) {
          return null;
        }
        return (
          <tr key={prod.name}>
            <td style={{ textAlign: 'left' }} className="productDescriptonCell">
              {prod.description}
            </td>
            <td style={{ textAlign: 'right' }}>{`$ ${productPrice.price}`}</td>
            <td style={{ textAlign: 'center' }}>{prod.quantity}</td>
            <td>{`$ ${getNetPrice(productPrice.price, prod.quantity)}`}</td>
          </tr>
        );
      })}
      <tr className="emptyTr row-mb-not">
        <td colSpan="3" style={{ textAlign: 'right' }}>
          Appliance Net Price:
        </td>
        <td style={{ textAlign: 'right' }} className="viewRowBlueColor">{`$${boxTotal.toFixed(
          2,
        )}`}</td>
      </tr>
    </>
  );
};

ProposalBoxView.propTypes = {
  boxName: PropTypes.string,
  boxTotal: PropTypes.number,
  box: PropTypes.shape({
    boxId: PropTypes.string,
    boxName: PropTypes.string,
    quantity: PropTypes.number,
    productGroups: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string,
          multiSelect: PropTypes.bool,
          deleted: PropTypes.bool,
          enabled: PropTypes.bool,
          products: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string,
              description: PropTypes.string,
              priceList: PropTypes.arrayOf(
                PropTypes.shape({
                  key: PropTypes.string,
                  desc: PropTypes.string,
                  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                }),
              ),
              selected: PropTypes.bool,
              quantity: PropTypes.number,
            }),
          ),
        }),
      ),
      PropTypes.objectOf(
        PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string,
          multiSelect: PropTypes.bool,
          deleted: PropTypes.bool,
          enabled: PropTypes.bool,
          products: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string,
              description: PropTypes.string,
              priceList: PropTypes.arrayOf(
                PropTypes.shape({
                  key: PropTypes.string,
                  desc: PropTypes.string,
                  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                }),
              ),
              selected: PropTypes.bool,
              quantity: PropTypes.number,
            }),
          ),
        }),
      ),
    ]),
  }).isRequired,
  productGroups: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      groupName: PropTypes.string,
      multiSelect: PropTypes.bool,
      deleted: PropTypes.bool,
      company: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string,
          priceList: PropTypes.arrayOf(
            PropTypes.shape({
              desc: PropTypes.string,
              price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              key: PropTypes.string,
            }),
          ),
        }),
      ),
    }),
  ),
  priceKey: PropTypes.string.isRequired,
};

ProposalBoxView.defaultProps = {
  boxName: '',
  productGroups: {},
  boxTotal: 0,
};

export default ProposalBoxView;
